import { HOUR_IN_MILLISECONDS } from 'config';
import {
  BreakingScheduleDto,
  PourDto,
  useGetBreakingScheduleQuery,
  usePourQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { CylinderBreakingTestParams } from './constants';

export type CylinderBreakingTestQueries = [
  UseQueryResult<PourDto, unknown>,
  UseQueryResult<BreakingScheduleDto, unknown>,
];

const useCylinderBreakingTestQueries = (params: CylinderBreakingTestParams): CylinderBreakingTestQueries => {
  const pourQuery = usePourQuery(params.pourId, { staleTime: HOUR_IN_MILLISECONDS });
  const breakingScheduleQuery = useGetBreakingScheduleQuery(params.breakingScheduleId, { staleTime: HOUR_IN_MILLISECONDS });

  return [pourQuery, breakingScheduleQuery];
};

export default useCylinderBreakingTestQueries;
